<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-percent"></i>
              Ingresá la retención de ganancias
            </h6>
            <button type="button" class="form-card__btn" @click="close">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label">Buscar hasta</label>
              <datepicker-component v-on:datechoosed="docsDateUpdated"/>
            </div>

            <div class="form-card__field">
              <label class="form-card__label">Fecha de retención</label>
              <datepicker-component v-on:datechoosed="dateUpdated"/>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="ew-amount">Valor</label>
              <input id="ew-amount" type="number" v-model="ew.amount" min="0" step="0.01" class="form-control" placeholder="0.00">
            </div>

            <div class="form-card__field">
              <label class="form-card__label">Comprobantes disponibles</label>
              <multiselect class="multiList" v-model="ew.outDocs"
              :options="inDocs"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="true"
              track-by="id"
              label="name"
              placeholder="Seleccione comprobantes"/>
              <small v-if="showWarning" class="text-danger d-block mt-1">Algunos de los documentos seleccionados no eran aptos. Es posible que ya se les haya aplicado una retención.</small>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="ew-note">Notas</label>
              <textarea id="ew-note" v-model="ew.note" class="form-control" rows="2"></textarea>
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button type="button" class="form-card__btn form-card__btn--primary" @click="saveew">
              <i class="bi bi-check-lg"></i>
              Pasar retención
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import datepickerComponent from '../global/Datepicker-empty.vue';
import Multiselect from 'vue-multiselect'

export default {
  props: ['client_id', 'selectedDocs','fromCC'],
  data() {
    return {
      ew: {
        outDocs: [],
        client_id: this.client_id,
        amount: 0,
        date: null,
        note:'',
      },
      inDocs: [],
      dateDocs: null,
      showWarning: false,
    }
  },
  mounted: function () {
        this.getDocs();
    },
  methods: {
    close() {
      this.$emit('close');
    },
    pluck(array, key) {
        return array.map(o => o[key]);
    },
    saveew() {
      let app = this;
      if (app.ew.amount<=0){
          alert("Ingrese un monto válido");
          return;
      }

      if (app.ew.outDocs.length<=0){
          if (confirm("No se ha seleccionado ningún comprobante para aplicar la retención ¿Desea crearla de todas maneras?")==false){
              return;
          }
      }

      this.$emit('updated', this.ew);
      this.$emit('close');
    },
    dateUpdated: function (date) {
      this.ew.date = date;
    },
    docsDateUpdated: function (date) {
      this.dateDocs = date;
      this.getDocs();
    },
    getDocs: function () {
        var app = this;
        var outdata = {
            'client_id': app.client_id,
            'toDate' : app.dateDocs,
        };

        this.$http.post('/api/clients/getDocsForWithholding', outdata)
        .then((response) => {
                if (response.data.success) {
                    app.inDocs = response.data.data;
                    app.checkSelected();
                }
            }).catch((error) => {
                console.log('error: '+error);
            });
    },
    checkSelected: function(){
        if(this.selectedDocs.length>0){
            var docs = this.selectedDocs.map(o=>o['sale_id']);
            var init= [];

            for (var doc in this.inDocs) {
                console.log(this.inDocs[doc].id);
                if (docs.includes(this.inDocs[doc]['id'])){
                    init.push(this.inDocs[doc]);
                }
            }

            if (init.length<this.selectedDocs.length)
            { this.showWarning = true;}

            this.ew.outDocs=init;
        }
    }
  },
  components: {
    datepickerComponent,
    Multiselect
  }
}
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>

